/* tslint:disable */
/* eslint-disable */
/**
 * Ad Asset Generation Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { mapValues } from '../runtime';
/**
 * Check if a given object implements the UploadAssetPost200Response interface.
 */
export function instanceOfUploadAssetPost200Response(value) {
    return true;
}
export function UploadAssetPost200ResponseFromJSON(json) {
    return UploadAssetPost200ResponseFromJSONTyped(json, false);
}
export function UploadAssetPost200ResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'] == null ? undefined : json['id'],
        'url': json['url'] == null ? undefined : json['url'],
    };
}
export function UploadAssetPost200ResponseToJSON(json) {
    return UploadAssetPost200ResponseToJSONTyped(json, false);
}
export function UploadAssetPost200ResponseToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'url': value['url'],
    };
}
